import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../../components/BreadCrumbs';
import Pagination from '../../../components/tables/pagination/Pagination';
import CustomLoading from '../../../components/customLoading/CustomLoading';
import Table from '../../../components/tables/Table';
import loaderImage from "../../../assets/icons/part-logo.png";
import StyledHeadingText from '../../../components/Fonts/StyledHeadingText';
import { getHudMachines } from '../../../services/hud/hud_machines';
import { toast } from 'react-toastify';


function HudMachines() {
    const [tableData, setTableData] = useState({});

    const headers = [
        { label: "Name", key: "name" },
        { label: "State", key: "state" },
        { label: "Country", key: "country" },
        { label: "No. Of Patients", key: "no_of_patients" },
    ];

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            let res = await getHudMachines();
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch machines");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Machines:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchData();
    }, []);

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/home' },
            { name: 'Machines', },
        ]} />
        <div className="flex flex-row justify-between py-4 items-center">
            <StyledHeadingText text={"History"} />
            {/* <Link to='/medicine/add'>
                <Button children={"Add Medicine"} className="bg-primary text-white rounded-lg" />
            </Link> */}
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading imageSrc={loaderImage} size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={tableData?.results?.map((item, index) => (
                            {
                                name: <p>{item.machine_name}</p>,
                                state: <p>{item.machine_state}</p>,
                                country: <p>{item.machine_country}</p>,
                                no_of_patients: <p>{item.patient_count}</p>,
                            }
                        )
                        )}
                    />
                </div>}
        {
            tableData.count !== 0 ?
                <div className="xl:pl-5 pl-0">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(tableData?.count / pageSize)}
                        pageSize={pageSize}
                        totalEntries={tableData?.count}
                        onPageChange={handlePageChange}
                        data={tableData}
                        setTableData={setTableData}
                    />
                </div> : <></>
        }
    </>);
}

export default HudMachines;